import React, { useState, useRef, useEffect } from 'react'
import { PlusIcon, PaperAirplaneIcon, MicrophoneIcon, StopIcon } from '@heroicons/react/24/solid'
import PulseLoader from 'react-spinners/PulseLoader'
import EtContentEditorLight2 from '@/utils/EtContentEditorLight2'
import { useCreateNewUserConversationMutation } from '@/features/userConversations/userConversationsApiSlice'
import { useGetContactsQuery } from '@/features/contacts/contactsApiSlice'
// import { useGetConversationTypesQuery } from '@/features/conversationTypes/conversationTypesApiSlice'

// 15 Jan 2026

import { useGetUserTrailSessionExecutionsQuery } from "@/features/userTrailSessions/userTrailSessionExecutionsApiSlice"
import { useGetSessionsQuery } from "@/features/sessions/sessionsApiSlice"
// import { useGetActionTypesQuery } from "@/features/actionTypes/actionTypesApiSlice"

import { useGetUserMissionClientsQuery } from '@/features/userMissions/userMissionClientsApiSlice'
import { useGetUserMissionOrgsQuery } from '@/features/userMissions/userMissionOrgsApiSlice'
import { useGetUserMissionPartnersQuery } from '@/features/userMissions/userMissionPartnersApiSlice'
import { useGetUserMissionSelfsQuery } from '@/features/userMissions/userMissionSelfsApiSlice'
import { useGetUserMissionTeamsQuery } from '@/features/userMissions/userMissionTeamsApiSlice'

import { useGetUserVisionClientsQuery } from '@/features/userVisions/userVisionClientsApiSlice'
import { useGetUserVisionOrgsQuery } from '@/features/userVisions/userVisionOrgsApiSlice'
import { useGetUserVisionPartnersQuery } from '@/features/userVisions/userVisionPartnersApiSlice'
import { useGetUserVisionSelfsQuery } from '@/features/userVisions/userVisionSelfsApiSlice'
import { useGetUserVisionTeamsQuery } from '@/features/userVisions/userVisionTeamsApiSlice'

import { useGetUserPlanClientsQuery } from '@/features/userPlans/userPlanClientsApiSlice'
import { useGetUserPlanOrgsQuery } from '@/features/userPlans/userPlanOrgsApiSlice'
import { useGetUserPlanPartnersQuery } from '@/features/userPlans/userPlanPartnersApiSlice'
import { useGetUserPlanSelfsQuery } from '@/features/userPlans/userPlanSelfsApiSlice'
import { useGetUserPlanTeamsQuery } from '@/features/userPlans/userPlanTeamsApiSlice'

import { useGetUserMissionGoalsQuery } from "@/features/userMissionGoals/userMissionGoalsApiSlice"

const EtCreateUserConversationLandingComp = ({
  userId,
  userOrgId,
  onClose = () => {},
  refetchUserConversations = () => {},
  //16 Jan 2026
  defaultTrailId='', // 15 Jan 2026
  defaultSessionId='', // 15 Jan 2026
}) => {

  // First Created: 09 Apr 2025  
  // Author - Atul Pandey  
  // Purpose - Create a standalone component to add a new user conversation from Trinity Web Landing 
  // Updated - 24 Apr 2025 - added flag for marking an impact as a magic moment - markAsMagicMoment flag 
  // Updated - 15 Jan 2026 - refactored for fields in UserConversationMaster to be used to connect a conversation to purpose native actions - vision, mission, mission goals, goal periods.
  
  // 1️⃣ ⬇ State Variables
  const [conversationText, setConversationText] = useState('')
  const [selectedContactId, setSelectedContactId] = useState('')
  const [selectedConversationTypeId, setSelectedConversationTypeId] = useState('')
  const [isRecording, setIsRecording] = useState(false)
  const [aiGeneratedResponse, setAiGeneratedResponse] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const [markAsMagicMoment, setMarkAsMagicMoment] = useState(false); // 24 Apr 2025

  // 15 Jan 2026 - State Variables for UserConversationMaster

  // const [selectedActionTypeId, setSelectedActionTypeId] = useState('')
  const [selectedTrailId, setSelectedTrailId] = useState(defaultTrailId)          
  const [selectedSessionId, setSelectedSessionId] = useState(defaultSessionId)    
  const [selectedFocus, setSelectedFocus] = useState('')
  const [selectedVisionId, setSelectedVisionId] = useState('')
  const [selectedMissionId, setSelectedMissionId] = useState('')
  const [selectedGoalId, setSelectedGoalId] = useState('')
  const [selectedGoalBreakdownId, setSelectedGoalBreakdownId] = useState(null)
  const [selectedPlanId, setSelectedPlanId] = useState('')


  const textareaRef = useRef(null)
  const recognitionRef = useRef(null)

  // 2️⃣ ⬇ Queries & Mutation
  const { data: contactsData } = useGetContactsQuery()
  // const { data: conversationTypesData } = useGetConversationTypesQuery()
  const [createNewUserConversation] = useCreateNewUserConversationMutation()

  const { data: userTrailSessionsData } = useGetUserTrailSessionExecutionsQuery() // 15 Jan 2026
  const { data: sessionsData } = useGetSessionsQuery()                            // 15 Jan 2026
  // const { data: actionTypesData } = useGetActionTypesQuery()                      // 15 Jan 2026

  const { data: userMissionClientsData } = useGetUserMissionClientsQuery()    // 15 Jan 2026
  const { data: userMissionOrgsData } = useGetUserMissionOrgsQuery()          // 15 Jan 2026
  const { data: userMissionPartnersData } = useGetUserMissionPartnersQuery()  // 15 Jan 2026
  const { data: userMissionSelfsData } = useGetUserMissionSelfsQuery()        // 15 Jan 2026
  const { data: userMissionTeamsData } = useGetUserMissionTeamsQuery()        // 15 Jan 2026
  
  const { data: userVisionClientsData } = useGetUserVisionClientsQuery()      // 15 Jan 2026
  const { data: userVisionOrgsData } = useGetUserVisionOrgsQuery()            // 15 Jan 2026
  const { data: userVisionPartnersData } = useGetUserVisionPartnersQuery()    // 15 Jan 2026
  const { data: userVisionSelfsData } = useGetUserVisionSelfsQuery()          // 15 Jan 2026
  const { data: userVisionTeamsData } = useGetUserVisionTeamsQuery()          // 15 Jan 2026

  const { data: userPlanClientsData } = useGetUserPlanClientsQuery()          // 15 Jan 2026
  const { data: userPlanOrgsData } = useGetUserPlanOrgsQuery()                // 15 Jan 2026
  const { data: userPlanPartnersData } = useGetUserPlanPartnersQuery()        // 15 Jan 2026
  const { data: userPlanSelfsData } = useGetUserPlanSelfsQuery()              // 15 Jan 2026
  const { data: userPlanTeamsData } = useGetUserPlanTeamsQuery()              // 15 Jan 2026

  const { data: userMissionGoalsData } = useGetUserMissionGoalsQuery()        // 15 Jan 2026
  

  const extractEntities = (adapter) => {
    if (!adapter?.ids || !adapter?.entities) return []
    return adapter.ids.map(id => adapter.entities[id])
  }

  // 15 Jan 2026
  const extractFilteredEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id])
    ?.filter(
        // (item) => item.userId?._id === userId && item?.userOrgId === userOrgId
        (item) => item.userId?._id === userId
        );
  };

  const contacts = extractEntities(contactsData)

  // 15 Jan 2026

  
  const userTrailSessions = extractFilteredEntitiesFromAdapter(userTrailSessionsData)
  // const actionTypes = extractEntities(actionTypesData);

  const userMissionClients = extractEntities(userMissionClientsData)?.filter(item => item.userId?._id === userId)     
  const userMissionOrgs = extractEntities(userMissionOrgsData)?.filter(item => item.userId?._id === userId)           
  const userMissionPartners = extractEntities(userMissionPartnersData)?.filter(item => item.userId?._id === userId)   
  const userMissionSelfs = extractEntities(userMissionSelfsData)?.filter(item => item.userId?._id === userId)         
  const userMissionTeams = extractEntities(userMissionTeamsData)?.filter(item => item.userId?._id === userId)         
  
  const userVisionClients = extractEntities(userVisionClientsData)?.filter(item => item.userId?._id === userId)     
  const userVisionOrgs = extractEntities(userVisionOrgsData)?.filter(item => item.userId?._id === userId)           
  const userVisionPartners = extractEntities(userVisionPartnersData)?.filter(item => item.userId?._id === userId)   
  const userVisionSelfs = extractEntities(userVisionSelfsData)?.filter(item => item.userId?._id === userId)         
  const userVisionTeams = extractEntities(userVisionTeamsData)?.filter(item => item.userId?._id === userId)         

  const userPlanClients = extractEntities(userPlanClientsData)?.filter(item => item.userId?._id === userId)     
  const userPlanOrgs = extractEntities(userPlanOrgsData)?.filter(item => item.userId?._id === userId)           
  const userPlanPartners = extractEntities(userPlanPartnersData)?.filter(item => item.userId?._id === userId)   
  const userPlanSelfs = extractEntities(userPlanSelfsData)?.filter(item => item.userId?._id === userId)         
  const userPlanTeams = extractEntities(userPlanTeamsData)?.filter(item => item.userId?._id === userId)         

  const userMissionGoals = extractEntities(userMissionGoalsData)?.filter(goal => goal.userId?._id === userId) 

  // 15 Jan 2026 - Extract Goals connected to the selected MissionId
  const filteredGoalOptions = userMissionGoals?.filter(
    (goal) => 
      goal.missionId?._id === selectedMissionId || 
      goal.missionId === selectedMissionId
  ) || []

  // 15 Jan 2026 - Helper functions for filtered dropdown options

  const filteredVisionOptions = (() => {
      switch (selectedFocus) {
        case 'Self': return userVisionSelfs || []
        case 'Client': return userVisionClients || []
        case 'Org': return userVisionOrgs || []
        case 'Team': return userVisionTeams || []
        case 'Partner': return userVisionPartners || []
        default: return []
      }
    })()
  
  const filteredMissionOptions = (() => {
    switch (selectedFocus) {
      case 'Self': return userMissionSelfs?.filter(m => m.visionId?._id === selectedVisionId || m.visionId === selectedVisionId) || []
      case 'Client': return userMissionClients?.filter(m => m.visionId?._id === selectedVisionId || m.visionId === selectedVisionId) || []
      case 'Org': return userMissionOrgs?.filter(m => m.visionId?._id === selectedVisionId || m.visionId === selectedVisionId) || []
      case 'Team': return userMissionTeams?.filter(m => m.visionId?._id === selectedVisionId || m.visionId === selectedVisionId) || []
      case 'Partner': return userMissionPartners?.filter(m => m.visionId?._id === selectedVisionId || m.visionId === selectedVisionId) || []
      default: return []
    }
  })()
  
  const filteredPlanOptions = (() => {
    switch (selectedFocus) {
      case 'Self': return userPlanSelfs?.filter(p => p.missionId?._id === selectedMissionId) || []
      case 'Client': return userPlanClients?.filter(p => p.missionId?._id === selectedMissionId) || []
      case 'Org': return userPlanOrgs?.filter(p => p.missionId?._id === selectedMissionId) || []
      case 'Team': return userPlanTeams?.filter(p => p.missionId?._id === selectedMissionId) || []
      case 'Partner': return userPlanPartners?.filter(p => p.missionId?._id === selectedMissionId) || []
      default: return []
    }
  })()

  // 15 Jan 2026 -  Group Sessions by Trail
  const trails = userTrailSessions?.reduce((acc, session) => {
    const trailId = session.trailId?._id;
    if (!acc[trailId]) {
      acc[trailId] = {
        trailId,
        trailName: session.trailId?.trailName || "Unnamed Trail",
        sessions: [],
      };
    }
    acc[trailId].sessions.push({
      sessionId: session?.sessionId?._id,
      sessionName: session.sessionId?.sessionName || "Unnamed Session",
    });
    return acc;
  }, {});

  // console.log('trails', trails)

  // 15 Jan 2026 -  Convert trails object to array of options
  const trailOptions = Object.values(trails || {});
  // console.log('trailOptions', trailOptions)

  // 15 Jan 2026 - Prepopulate actionType for "MyMissions"
  // useEffect(() => {
  //   const selectedTrail = trailOptions.find(t => t.trailId === selectedTrailId)
  //   const trailName = selectedTrail?.trailName

  //   if (trailName === "MyMissions" && actionTypes?.length > 0) {
  //     const missionActionType = actionTypes.find(a => a.actionTypeName === "Mission")
  //     if (missionActionType) {
  //       setSelectedActionTypeId(missionActionType._id)
  //     }
  //   }
  // // }, [selectedTrailId, actionTypes])
  // }, []) // 14 Sep 2025 - to make it run only once.
  
    // 15 Jan 2026 - Goal Period Breakdown
    const selectedGoalObj = filteredGoalOptions?.find(goal => goal._id === selectedGoalId);
  
    const goalBreakdownList =
    selectedFocus === "Client" || selectedFocus === "Org" || selectedFocus === "Partner"
      ? selectedGoalObj?.sharedGoalId?.goalBreakdown || []
      : selectedGoalObj?.goalBreakdown || [];

  // const conversationTypes = extractEntities(conversationTypesData)

  // 3️⃣ ✅ Handle Submit
  const handleSubmit = async (finalText) => {
    // Validation
    // if (!selectedConversationTypeId) {
    //   alert("Please select a Conversation Type");
    //   return;
    // }

    if (!finalText.trim()) {
        alert("Conversation note cannot be empty.");
        return;
      }
  
    // if (!conversationText || conversationText.trim() === "") {
    //     alert("Conversation note cannot be empty.");
    //     return;
    //   }
  
    // Build the payload
    const payload = {
      userId,
      userOrgId
    };
  
    if (selectedContactId) {
      // Contact-specific note
      payload.userConversationContactNotes = [
        {
          // userConversationTypeId: selectedConversationTypeId,
          userContactId: selectedContactId,
          userConversationContactNoteText: finalText,
          userConversationContactNoteDate: new Date().toISOString(),
          userConversationContactNoteUpdateDate: new Date().toISOString(),
          markAsMagicMoment // 24 Apr 2025
        }
      ];
    } else {
      // Self note
      payload.userConversationAllNotes = [
        {
          // userConversationTypeId: selectedConversationTypeId,
          userConversationAllNoteText: finalText,
          userConversationAllNoteDate: new Date().toISOString(),
          userConversationAllNoteUpdateDate: new Date().toISOString(),
          markAsMagicMoment // 24 Apr 2025
        }
      ];
    }

    // 15 Jan 2026 - UserConversationMaster related fields:

    payload.conversationContext = {
      selectedFocus: selectedFocus || undefined,

      connectedEntities: [
        selectedVisionId && {
          entityType: 'Vision',
          entityId: selectedVisionId,
        },
        selectedMissionId && {
          entityType: 'Mission',
          entityId: selectedMissionId,
        },
        selectedGoalId && {
          entityType: 'MissionGoal',
          entityId: selectedGoalId,
          goalBreakdownId: selectedGoalBreakdownId || undefined,
        },
        selectedPlanId && {
          entityType: 'Plan',
          entityId: selectedPlanId,
        },
      ].filter(Boolean),
    }

    // 15 Jan 2026
    if (selectedTrailId) payload.trailId = selectedTrailId
    if (selectedSessionId) payload.sessionId = selectedSessionId

  
    try {
      await createNewUserConversation(payload).unwrap();
  
      // Reset the form
      setSelectedContactId("");
      // setSelectedConversationTypeId("");
      setConversationText("");
      setMarkAsMagicMoment(false); // ✅ 24 Apr 2025 Reset the checkbox
  
      // Refetch if provided
      if (refetchUserConversations) {
        refetchUserConversations();
      }
  
      if (onClose) {
        onClose();
      }
  
    } catch (err) {
      console.error("Error creating conversation:", err);
      alert("Failed to create conversation. Please try again.");
    }
  };
  
    // 4️⃣ ⬇ AI Generation Helpers

    // 4a - aiPrompt
    const aiPrompt = `
    Summarize the following text into a concise, well-structured note in **HTML format**. Organize key points into a numbered list, with the first word of each item wrapped in <strong> tags for emphasis. Ensure the output is clean and readable, with paragraphs and spacing between sections. Do not include a subject line or closing statement. Do not include any salutations like "Dear Team" etc. Only return the HTML without additional comments:
  
    "${conversationText}"
    `;
  
    // 4b - Function to process response chunks
    const handleResponseChunk = (chunk) => {
      setAiGeneratedResponse((prev) => prev + chunk)
    }
  
    // 4c - Function to process final response once ai stream is complete
    const handleComplete = (finalResponse) => {
      setIsModalOpen(true)
      setAiGeneratedResponse("")
      setTimeout(() => simulateTypingEffect(finalResponse), 500)
      setLoading(false)
    }
  
    // 4d - Handle errors during the AI generation process
    const handleError = (error) => {
      console.error("Error generating AI response:", error)
      alert("Something went wrong. Please try again.")
      setLoading(false)
    }
  
    // 4e - Generate AI reponse function
    const generateAIResponse = (prompt, onResponseChunk, onComplete, onError) => {
      try {
        const eventSource = new EventSource(
          `${process.env.REACT_APP_SERVER_URL}/trinity/generateResponse?` +
          `messages=${encodeURIComponent(JSON.stringify([
            { role: "system", content: "Generate a refined professional note." },
            { role: "user", content: prompt }
          ]))}&maxTokens=5000&model=${encodeURIComponent("gpt-4")}`
        )
  
        let response = ""
  
        eventSource.onmessage = (event) => {
          const chunk = event.data
          response += chunk
          onResponseChunk(chunk)
        }
  
        eventSource.addEventListener("end", () => {
          eventSource.close()
          onComplete(response)
        })
  
        eventSource.onerror = (error) => {
          eventSource.close()
          onError(error)
        }
      } catch (err) {
        onError(err)
      }
    }
  
    // 4f - Function to generate response
    const handleGenerateAIResponse = () => {
      if (!conversationText.trim()) return
  
      setIsModalOpen(true)
      setLoading(true)
  
      generateAIResponse(aiPrompt, handleResponseChunk, handleComplete, handleError)
    }
  
    // 5 - Simulate typing effect
    const simulateTypingEffect = (text) => {
      let index = 0
      const words = text.split(" ")
      let displayedText = ""
  
      const interval = setInterval(() => {
        if (index < words.length) {
          displayedText += words[index] + " "
          setAiGeneratedResponse(displayedText)
          index++
        } else {
          clearInterval(interval)
        }
      }, 100)
    }

    // 6-  ✅ Derived flag for MyMissions context - 15 Jan 2026
    const isMyMissionsTrail =
    selectedTrailId &&
    trailOptions.find(t => t.trailId === selectedTrailId)?.trailName === "MyMissions";

    // 7 - ✅ Sessions strictly scoped to selected trail - 15 Jan 2026
    // ✅ Session options should come ONLY from selected trail inside trailOptions
    const selectedTrailOption = trailOptions?.find(t => t.trailId === selectedTrailId);

    // ✅ Optional: dedupe sessions by sessionId (your IgnitiON sample shows duplicates)
    const selectedTrailSessions = selectedTrailOption?.sessions
      ? Array.from(new Map(selectedTrailOption.sessions.map(s => [s.sessionId, s])).values())
      : [];


  return (
    <div className="p-4 bg-white rounded shadow-md font-poppins text-sm">
      <p className="text-lg font-bold text-orange-600 mb-2">Add a New Conversation</p>

      {/* Contact Dropdown */}
      <div className="mb-2">
        <label className="block text-xs font-bold text-gray-600">Contact (optional)</label>
        <select
          value={selectedContactId}
          onChange={(e) => setSelectedContactId(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded"
        >
          <option value="">Self</option>
          {contacts.map((c) => (
            <option key={c._id} value={c._id}>
              {c.contactName} - {c.contactTypeId?.contactTypeName}
            </option>
          ))}
        </select>
      </div>

      {/* Type Dropdown */}
      {/* <div className="mb-2">
        <label className="block text-xs font-bold text-gray-600">Conversation Type</label>
        <select
          value={selectedConversationTypeId}
          onChange={(e) => setSelectedConversationTypeId(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded"
        >
          <option value="">Select Type</option>
          {conversationTypes.map((t) => (
            <option key={t._id} value={t._id}>
              {t.conversationTypeName}
            </option>
          ))}
        </select>
      </div> */}

      {/* 15 Jan 2026 - Fields for UserConversationMaster */}

      {/* Trail & Sessions */}
      <div className='flex justify-between items-center'>

          {/* Trail Selection */}
          <div className='w-full mr-1 pr-1'>
            <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Trail</p>
            <select
                value={selectedTrailId}
                onChange={(e) => {
                  setSelectedTrailId(e.target.value)
                  setSelectedSessionId("")

                  // 🔁 Reset purpose context when trail changes
                  setSelectedFocus('')
                  setSelectedVisionId('')
                  setSelectedMissionId('')
                  setSelectedGoalId('')
                  setSelectedGoalBreakdownId(null)
                  setSelectedPlanId('')
                }}
                disabled={!!defaultTrailId} // ✅ 17 May 2025 Disable if default provided
                className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
            >
                <option value="">Select Trail</option>
                {trailOptions?.map(trail => (
                <option key={trail.trailId} value={trail.trailId}>
                    {trail.trailName}
                </option>
                ))}
            </select>
          </div>
          
          {/* Session Selection */}

          <div className='w-full ml-1 pl-1'>
            <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Session</p>
            <select
                value={selectedSessionId}
                onChange={(e) => {
                  setSelectedSessionId(e.target.value)
                }}
                disabled={!!defaultSessionId || !selectedTrailId}
                className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
            >
                <option value="">Select Session</option>
                {selectedTrailSessions.map(session => (
                  <option key={session.sessionId} value={session.sessionId}>
                    {session.sessionName}
                  </option>
                ))}
                {/* {selectedTrailId &&
                trails[selectedTrailId]?.sessions.map(session => (
                    <option key={session.sessionId} value={session.sessionId}>
                    {session.sessionName}
                    </option>
                ))} */}
            </select>
          </div>
          
      
      </div>
      

      {/* 15 Jan 2026 - Only show Focus dropdown if trail is MyMissions */}
        
      {selectedTrailId && trailOptions.find(t => t.trailId === selectedTrailId)?.trailName === "MyMissions" && (
      <>
          
          <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Focus Area <span className='font-normal text-gray-700 italic text-xs'>(e.g., Self, Client, Org...)</span> </p>
          {/* a) Focus Selector */}
          <select
          value={selectedFocus}
          onChange={(e) => {
              setSelectedFocus(e.target.value)
              setSelectedVisionId('')
              setSelectedMissionId('')
              setSelectedGoalId('')
              setSelectedGoalBreakdownId(null)
              setSelectedPlanId('')
          }}
          className="w-full border border-gray-300 rounded-lg p-3 mb-3 focus:outline-none focus:ring-1 focus:ring-orange-500"
          >
          <option value="">Select Focus (Self, Client...)</option>
          <option value="Self">Self</option>
          <option value="Client">Client</option>
          <option value="Org">Org</option>
          <option value="Team">Team</option>
          <option value="Partner">Partner</option>
          </select>

          {/* b) Vision Dropdown */}
          
          {selectedFocus && (
          <>
            <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Vision</p>
            <select
                value={selectedVisionId}
                onChange={(e) => {
                setSelectedVisionId(e.target.value)
                setSelectedMissionId('')
                setSelectedPlanId('')
                }}
                className="w-full border border-gray-300 rounded-lg p-3 mb-3 focus:outline-none focus:ring-1 focus:ring-orange-500"
            >
                <option value="">Select Vision</option>
                {/* {filteredVisionOptions?.map((vision) => (
                <option key={vision._id} value={vision._id}>
                    {vision.visionName}
                </option>
                ))} */}

                {/* 18 Aug 2025 */}
                {filteredVisionOptions?.map((vision) => {
                  const displayName = vision?.sharedVisionId
                    ? vision?.sharedVisionId?.visionName
                    : vision?.visionName;

                  return (
                    <option key={vision._id} value={vision._id}>
                      {displayName}
                    </option>
                  );
                })}
            </select>
          </>
          )}

          {/* c) Mission Dropdown */}
          
          {selectedVisionId && (
          <>
            <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Mission</p>
            <select
                value={selectedMissionId}
                onChange={(e) => {
                setSelectedMissionId(e.target.value)
                setSelectedPlanId('')
                }}
                className="w-full border border-gray-300 rounded-lg p-3 mb-3 focus:outline-none focus:ring-1 focus:ring-orange-500"
            >
                <option value="">Select Mission</option>
                {/* {filteredMissionOptions?.map((mission) => (
                <option key={mission._id} value={mission._id}>
                    {mission.missionName}
                </option>
                ))} */}

                {/* 18 Aug 2025 */}
                {filteredMissionOptions?.map((mission) => {
                  const displayName = mission?.sharedMissionId
                    ? mission?.sharedMissionId?.missionName
                    : mission?.missionName;

                  return (
                    <option key={mission._id} value={mission._id}>
                      {displayName}
                    </option>
                  );
                })}
            </select>
          </>
          )}

          {/* d) Plan Dropdown */}
          
          {selectedMissionId && filteredPlanOptions?.length >0 && ( //31 Aug 2025 - added .length condition to display plans only when those exist
            <>
              <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Plan</p>
              <select
                  value={selectedPlanId}
                  onChange={(e) => setSelectedPlanId(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-3 mb-3 focus:outline-none focus:ring-1 focus:ring-orange-500"
              >
                  <option value="">Select Plan</option>
                  {filteredPlanOptions?.map((plan) => (
                  <option key={plan._id} value={plan._id}>
                      {plan.planName}
                  </option>
                  ))}
              </select>
            </>
          )}
      </>
      )}

      {/* 30 Aug 2025 - Select Mission Goal */}        
      {isMyMissionsTrail && selectedFocus && selectedVisionId &&  selectedMissionId && (
        <>
          <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Goal</p>
          <select
            value={selectedGoalId}
            onChange={(e) => setSelectedGoalId(e.target.value)}
            className="w-full border border-gray-300 rounded-lg p-3 mb-3 focus:outline-none focus:ring-1 focus:ring-orange-500"
          >
            <option value="">Select Goal (optional)</option>
            {filteredGoalOptions?.map((goal) => {
              const displayName = goal?.sharedGoalId
                ? goal.sharedGoalId.goalName
                : goal.goalName;

              return (
                <option key={goal._id} value={goal._id}>
                  {displayName}
                </option>
              );
            })}
          </select>
        </>

      )}

      {/* 12 Sep 2025 - Select Goal Period if Goal is selected */}
      { isMyMissionsTrail &&
        selectedFocus &&
        selectedVisionId &&
        selectedMissionId &&
        goalBreakdownList.length > 0 && (
        <div className="my-2">
          {/* 1️⃣ Label */}
          <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Select Goal Period</p>

          {/* 2️⃣ Button-style chips */}
          <div className="flex flex-wrap gap-2 bg-white rounded m-1 p-2">
            {goalBreakdownList.map((period) => {
              const isSelected = selectedGoalBreakdownId === period._id;
              const displayLabel = period.periodLabel || `${period.periodType} – ${period.period}`;

              return (
                <button
                  key={period._id}
                  type="button"
                  onClick={() =>
                    setSelectedGoalBreakdownId(isSelected ? "" : period._id) // toggle off if clicked again
                  }
                  className={`px-3 py-1 rounded-full text-sm border font-medium transition
                    ${
                      isSelected
                        ? "bg-orange-500 text-white border-orange-500"
                        : "bg-white text-gray-700 border-gray-300 hover:bg-orange-100"
                    }`}
                >
                  {displayLabel}
                </button>
              );
            })}
          </div>
        </div>
      )}

      

      {/* Action Type Selection */}
      {/* <p className="font-bold text-orange-800 mt-2 pt-2 mx-1 px-1">Action Type</p>
      <select
          value={selectedActionTypeId}
          onChange={(e) => setSelectedActionTypeId(e.target.value)}
          className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-orange-500"
      >
          <option value="">Select Action Type</option>
          {actionTypesData?.ids.map(id => {
          const actionType = actionTypesData.entities[id]
          // console.log('actionType', actionType)
          return (
              <option key={id} value={id}>
              {actionType?.actionTypeName}
              </option>
          )
          })}
      </select> */}


      {/* Editor */}
      <div className="mb-2">
        <label className="block text-xs font-bold text-gray-600">Note</label>
        <EtContentEditorLight2
          value={conversationText}
          handleChange={setConversationText}
          placeholderText="Write your conversation here..."
          editorKey={`conversation-note`}
        />
      </div>

      {/* 24 Apr 2025 - Mark as Magic Moment */}
      <div className="flex items-center space-x-2 mb-2">
        <input
          type="checkbox"
          id="markAsMagicMoment"
          checked={markAsMagicMoment}
          onChange={() => setMarkAsMagicMoment(prev => !prev)}
          className="w-4 h-4"
        />
        <label htmlFor="markAsMagicMoment" className="text-xs text-gray-700 font-medium">
          Mark this as a Magic Moment
        </label>
      </div>

      {/* Button Bar */}
      <div className="flex justify-end space-x-2 mt-3">
        <button
          onClick={() => setIsConfirmModalOpen(true)}
          className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700 flex items-center"
        >
          <PaperAirplaneIcon className="h-4 w-4 mr-1" />
          Submit
        </button>
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
        >
          Cancel
        </button>
      </div>

      {/* Modals: AI Confirm + AI Output → to be added next step */}
      {isConfirmModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-lg font-semibold mb-4">Need Trinity's touch?</h2>
            <p className="text-sm text-gray-600 mb-4">
                Would you like to refine your note with Trinity, or submit it directly?
            </p>
            <div className="flex justify-end space-x-4">
                <button
                className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                onClick={() => {
                    setIsConfirmModalOpen(false);
                    handleSubmit(conversationText); // Submit directly
                }}
                >
                Submit Directly
                </button>
                <button
                className="p-2 bg-orange-600 text-white rounded hover:bg-orange-700"
                onClick={() => {
                    setIsConfirmModalOpen(false);
                    handleGenerateAIResponse(); // Refine with AI
                }}
                >
                Refine with Trinity
                </button>
            </div>
            </div>
        </div>
      )}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h2 className="text-lg font-semibold mb-4">Review and Edit</h2>

            {loading ? (
                <div className="flex justify-start items-center">
                <p className="text-sm mx-1 px-1">Generating response…</p>
                <div className="bg-orange-600 p-2 rounded">
                    <PulseLoader color={"#fff"} />
                </div>
                </div>
            ) : (
                <>
                {/* Original Note */}
                <div className="mb-4">
                    <h3 className="text-sm font-bold text-gray-600">Original Note</h3>
                    <textarea
                    value={conversationText}
                    readOnly
                    rows={4}
                    className="w-full border border-gray-300 rounded-lg p-3 bg-gray-100 focus:outline-none overflow-y-auto"
                    />
                </div>

                {/* Refined Note */}
                <div className="mb-4">
                    <h3 className="text-sm font-bold text-gray-600">Trinity Refined Note</h3>
                    {(() => {
                    const plainTextResponse = aiGeneratedResponse.replace(/<[^>]+>/g, '');
                    return (
                        <textarea
                        value={plainTextResponse}
                        onChange={(e) => setAiGeneratedResponse(e.target.value)}
                        rows={6}
                        className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none resize-y"
                        />
                    );
                    })()}
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end space-x-4 mt-4">
                    <button
                    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    onClick={() => setIsModalOpen(false)}
                    >
                    Cancel
                    </button>
                    <button
                    className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700"
                    onClick={() => {
                        const combinedText = `<strong>Trinity Refined:</strong>\n\n${aiGeneratedResponse}\n\n<strong>My Note:</strong>\n\n${conversationText}`;
                        setConversationText(combinedText);
                        setIsModalOpen(false);
                        handleSubmit(combinedText); // Final submission
                    }}
                    disabled={loading}
                    >
                    Confirm
                    </button>
                </div>
                </>
            )}
            </div>
        </div>
       )}

    </div>
  )
}

export default EtCreateUserConversationLandingComp